import { createApp } from "vue";
import Projects from "./Projects.vue";

const app = createApp({
  components: {
    "projects-component": Projects,

  },
}).mount("#container-projects");
